import VueI18n from 'vue-i18n'

import VueMapkit from 'vue-mapkit'

import SvgVue from 'svg-vue';

window.Vue = require('vue').default;

import * as Sentry from "@sentry/vue";

import CountryFlag from 'vue-country-flag'

import { LMap, LTileLayer, LMarker, LIcon, } from "vue2-leaflet";
import VueLoadImage from 'vue-load-image'
import Vue from 'vue';

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);
Vue.use(SvgVue);

import checkView from 'vue-check-view'
import en from "../../lang/en.json";
import nl from "../../lang/nl.json";
import de from "../../lang/de.json";
import es from "../../lang/es.json";
import fr from "../../lang/fr.json";
import pt from "../../lang/pt.json";
import gr from "../../lang/gr.json";

// Import route modules
import dashboardRoutes from "./dashboard/router";
import locationRoutes from "./components/map/locationsrouter";

import VueRouter from 'vue-router';

const router = new VueRouter({
    mode: 'history',
    routes: [
        ...dashboardRoutes,
        ...locationRoutes
    ]
});

Vue.use(checkView)

import filters from './filters';

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

const i18n = new VueI18n({
    locale: document.documentElement.lang,
    fallbackLocale: process.env.DEFAULT_LANGUAGE,
    seo: true,
    messages: {
        en, nl, es, pt, fr, de, gr
    }
})

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

Vue.use(VueToast);

!(('ontouchstart' in window) && !(navigator.msMaxTouchPoints > 0)) ? document.querySelector('body').classList.add('no_touch') : null;

Vue.prototype.$appName = process.env.APP_NAME
Vue.prototype.$main_color = getComputedStyle(document.body).getPropertyValue("--main_color");
Vue.prototype.$main_color_darkmode = getComputedStyle(document.body).getPropertyValue("--dark-main_color");
Vue.prototype.$main_color_bright = getComputedStyle(document.body).getPropertyValue("--main_color_bright");
Vue.prototype.$main_color_brighter = getComputedStyle(document.body).getPropertyValue("--main_color_brighter");
Vue.prototype.$sub_color = getComputedStyle(document.body).getPropertyValue("--sub_color");
Vue.prototype.$third_color = getComputedStyle(document.body).getPropertyValue("--third_color");

Vue.prototype.$dark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
Vue.prototype.$hostName = window.location.host;
Vue.prototype.$baseUrl = window.location.protocol + "//" + window.location.host;
Vue.prototype.$homeUrl = document.documentElement.getAttribute('default_lang') == document.documentElement.lang ? Vue.prototype.$baseUrl : window.location.protocol + "//" + window.location.host + "/" + document.documentElement.lang;
Vue.prototype.$termsUrl = Vue.prototype.$homeUrl + "/termsandconditions"
Vue.prototype.$path = window.location.pathname + window.location.search + window.location.hash;

Vue.prototype.$BMB_API = process.env.MIX_APP_LOCAL ? 'https://boostmybookings.test/' : 'https://boostmybookings.com/';
Vue.prototype.$clientID = window.clientID;


import MouseGradient from './directives/v-mouse-gradient.js'
Vue.directive('mouse-gradient', MouseGradient)

Vue.use(CountryFlag);

Vue.component(
    'l-map',
    LMap
);
Vue.component(
    'l-tile-layer',
    LTileLayer
);
Vue.component(
    'l-marker',
    LMarker
);
Vue.component(
    'l-icon',
    LIcon
);

Vue.component(
    'small_text_editor',
    require('./components/small_text_editor.vue').default
)

Vue.component(
    'dashboard',
    require('./dashboard/dashboard-main.vue').default
)

Vue.component(
    'event_schedule',
    require('./components/elements/event_schedule.vue').default
)

Vue.component(
    'live_location_ask',
    require('./components/elements/live_location_ask.vue').default
)

Vue.component(
    'scroll_buttons',
    require('./components/elements/scroll_buttons.vue').default
)

Vue.component(
    'cookiebar',
    require('./components/elements/cookiebar.vue').default
)

Vue.component(
    'timetable',
    require('./components/elements/timetable.vue').default
)

Vue.component(
    'notification',
    require('./components/elements/notification.vue').default
)

Vue.component(
    'vue-load-image',
    VueLoadImage
);

Vue.component(
    'check_tickets_availability',
    require('./components/elements/check_tickets_availability.vue').default
);

Vue.component(
    'app_dropdown',
    require('./components/elements/dropdown/AppDropdown.vue').default
);

Vue.component(
    'app_modal',
    require('./components/elements/modal/Modal.vue').default
);

Vue.component(
    'app_dropdown_content',
    require('./components/elements/dropdown/AppDropdownContent.vue').default
);

Vue.component(
    'home_acco',
    require('./components/home_acco.vue').default
);

Vue.component(
    'appAccordion',
    require('./components/elements/appAccordion.vue').default
)

Vue.component(
    'appTabs',
    require('./components/elements/appTabs.vue').default
)

Vue.component(
    'likebutton',
    require('./components/elements/likebutton.vue').default
);

Vue.component(
    'filterbar',
    require('./components/elements/filterbar.vue').default
);

Vue.component(
    'filtermenu',
    require('./components/elements/filtermenu.vue').default
);

Vue.component(
    'home_recently_viewed',
    require('./components/home_recently_viewed.vue').default
)

Vue.component(
    'accomodation_lister_compact',
    require('./components/accomodation_lister_compact.vue').default
);

Vue.component(
    'navbar',
    require('./components/elements/navbar.vue').default
)

Vue.component(
    'navbar_button',
    require('./components/elements/navbar_button.vue').default
)

Vue.component(
    'events_filter_modal',
    require('./components/elements/events_filter_modal.vue').default
)

Vue.component(
    'accomodation_lister_map',
    require('./components/accomodation_lister_map.vue').default
);

Vue.component(
    'accomodation_lister',
    require('./components/accomodation_lister.vue').default
);

Vue.component(
    'acco_page',
    require('./components/acco_page.vue').default
);

Vue.component(
    'acco_houserules',
    require('./components/acco_houserules.vue').default
);

Vue.component(
    'acco_policy',
    require('./components/acco_policy.vue').default
)

Vue.component(
    'search_results',
    require('./components/searchbox/search_results.vue').default
)

Vue.component(
    'acco_searchbutton_nav',
    require('./components/searchbox/acco_searchbutton_nav.vue').default
)

Vue.component(
    'general_searchbox',
    require('./components/searchbox/general_searchbox.vue').default
)

Vue.component(
    'general_searchbox_mobile',
    require('./components/searchbox/general_searchbox_mobile.vue').default
)

Vue.component(
    'home_hero',
    require('./components/home_hero.vue').default
)

Vue.component(
    'general_searchbox_page',
    require('./components/searchbox/general_searchbox_page.vue').default
)

Vue.component(
    'small_mobile_search_button',
    require('./components/searchbox/small_mobile_search_button.vue').default
)

Vue.component(
    'booking_box',
    require('./components/bookingbox.vue').default
)

Vue.component(
    'acco_searchbox',
    require('./components/searchbox/acco_searchbox.vue').default
)

Vue.component(
    'acco_searchbox_location',
    require('./components/searchbox/acco_searchbox_location.vue').default
)

Vue.component(
    'category_type',
    require('./components/category_type.vue').default
)

Vue.component(
    'mapbox',
    require('./components/mapbox.vue').default
)

Vue.component(
    'maplibre',
    require('./components/maplibre.vue').default
)

Vue.component(
    'events',
    require('./components/events_index.vue').default
)

Vue.component(
    'acco_searchbox_calendar',
    require('./components/searchbox/acco_searchbox_calendar.vue').default
)

Vue.component(
    'acco_searchbox_guests',
    require('./components/searchbox/acco_searchbox_guests.vue').default
)

Vue.component(
    'portimao_text',
    require('./components/portimao_text.vue').default
)

Vue.component(
    'share-button',
    require('./components/elements/sharebutton.vue').default
)

Vue.component(
    'subscriber_signup',
    require('./components/elements/subscriber_signup.vue').default
)

Vue.component(
    'iframe_map',
    require('./components/iframe_map.vue').default
)

Vue.component(
    'register_block',
    require('./components/elements/register_block.vue').default
)

Vue.component(
    'login_block',
    require('./components/elements/login_block.vue').default
)

Vue.component(
    'verify_email',
    require('./components/elements/verify_email.vue').default
)

Vue.component(
    'password_reset',
    require('./components/elements/password_reset.vue').default
)

Vue.component(
    'password_forgotten',
    require('./components/elements/password_forgotten.vue').default
)

Vue.component(
    'event_submit',
    require('./components/elements/event_submit.vue').default
)

Vue.component(
    'location_submit',
    require('./components/elements/location_submit.vue').default
)


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

if (process.env.NODE_ENV == 'production') {
    Sentry.init({
        Vue,
        dsn: "https://a34e9dbcde904e5ebf9f60b9dfecb54e@o4505193544744960.ingest.sentry.io/4505209539788800",
        environment: 'production',
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for tracing.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.7,
    });
}

new Vue({
    el: '#app',
    router,
    i18n,
});
